import { render, staticRenderFns } from "./SocialForm.vue?vue&type=template&id=7edef2b4&scoped=true&"
import script from "./SocialForm.vue?vue&type=script&lang=ts&"
export * from "./SocialForm.vue?vue&type=script&lang=ts&"
import style0 from "./SocialForm.vue?vue&type=style&index=0&id=7edef2b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edef2b4",
  null
  
)

export default component.exports